<template>
  <div v-if="errorMessage" class="content alert alert-danger" role="alert">
    <h4 class="alert-heading">An error has occured</h4>
    <p>{{ errorMessage }}</p>
  </div>
  <div class="content d-flex flex-grow">
    <h1 v-if="event.name" class="content-title flex-grow-1">
      {{ event.name }}
    </h1>
    <h1 v-else class="content-title flex-grow-1">New Event</h1>
  </div>
  <form
    class="card"
    @submit.prevent="eventId ? saveEvent(event) : addEvent(event)"
    autocomplete="off"
  >
    <fieldset class="form-group">
      <label class="w-full text-xl p-2" for="name">What is this event?</label>
      <input
        class="form-control"
        type="text"
        id="name"
        name="name"
        v-model="event.name"
        required
      />
    </fieldset>
    <fieldset class="form-group">
      <label class="" for="name">Enter any more details here</label>
      <textarea
        class="form-control"
        id="description"
        name="description"
        v-model="event.description"
      ></textarea>
    </fieldset>
    <fieldset class="form-group">
      <label class="" for="date">Date</label>
      <input
        class="form-control"
        type="date"
        id="date"
        name="date"
        v-model="event.date"
      />
    </fieldset>
    <fieldset class="form-group">
      <label class="" for="name">Type</label>
      <select
        class="form-control"
        id="description"
        name="description"
        v-model="event.type"
        required
      >
        <option
          id="type"
          name="type"
          v-for="option in options.types"
          :value="option.value"
          :key="option.value"
          >{{ option.text }}
        </option>
      </select>
    </fieldset>
    {{ saving }}
    <fieldset class="d-flex">
      <button
        class="btn btn-primary mx-10"
        type="submit"
        id="submit"
        name="submit"
        :svalue="saving ? 'Saving' : 'Save'"
        :disabled="saving"
      >
        <i
          dclass="far fa-check-square"
          :class="saving ? 'fas fa-spinner fa-spin' : 'far fa-check-square'"
        ></i>
        <span class="ml-5">{{ saving ? "Saving" : "Save" }}</span>
      </button>
      <a @click="$router.back()" class="btn mx-10">Cancel</a>
      <div class="flex-grow-1 text-right">
        <a
          v-if="eventId && !confirmDeletion"
          @click="confirmDelete(gift)"
          class="btn btn-danger mx-10"
          >Delete</a
        >
        <a
          v-if="eventId && confirmDeletion"
          @click="deleteEvent(event)"
          class="btn btn-danger mx-10"
          >Are you sure?</a
        >
      </div>
    </fieldset>
  </form>
  <div v-if="eventId" class="card m-10 p-10 col-lg">
    <h3 class="m-0 mb-5 p-0 font-size-16">Members</h3>
    <ul>
      <li v-for="member in members" :key="member.id">{{ member.name }}</li>
    </ul>
  </div>
</template>

<script>
import { db, auth, firebase } from "../../../lib/firebase.js";

export default {
  name: "EditEvent",
  components: {},
  props: ["eventId"],
  data() {
    return {
      event: {
        id: this.eventId,
        name: "",
        description: "",
        date: "",
        type: "",
        owner: {},
      },
      members: [],
      options: {
        types: [
          { value: "christmas", text: "Christmas" },
          { value: "birthday", text: "Birthday" },
          { value: "wedding", text: "Wedding" },
        ],
      },
      confirmDeletion: false,
      saving: false,
      errorMessage: null,
    };
  },
  methods: {
    async getEvent(eventId) {
      try {
        const eventRef = db.collection("events").doc(eventId);
        const doc = await eventRef.get();
        var event = doc.data();
        event.id = doc.id;
        return event;
      } catch (error) {
        this.errorMessage = error.message;
        return null;
      }
    },
    async addEvent(event) {
      try {
        this.saving = true;
        event.owner = {
          id: auth.currentUser.uid,
          name: auth.currentUser.displayName,
        };
        delete event.id;
        const batch = db.batch();
        const newEventRef = db.collection("events").doc();
        batch.set(newEventRef, this.event);
        const newMemberRef = newEventRef
          .collection("members")
          .doc(auth.currentUser.uid);
        batch.set(newMemberRef, { name: auth.currentUser.displayName });
        await batch.commit();
        window.analytics.track("Event created", {
          event: event,
        });
        firebase.analytics().logEvent("event_created", { type: event.type });
        setTimeout(() => {
          this.$router.back();
        }, 1500);
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    async saveEvent(event) {
      try {
        await db
          .collection("events")
          .doc(event.id)
          .set(event);
        this.$router.back();
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    async deleteEvent(event) {
      try {
        await db
          .collection("events")
          .doc(event.id)
          .update({ deleted: true });
        this.confirmDeletion = false;
        this.$router.back();
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    confirmDelete() {
      this.confirmDeletion = true;
    },
    async getMembers(eventId) {
      try {
        const querySnapshot = await db
          .collection("events")
          .doc(eventId)
          .collection("members")
          .get();
        const members = querySnapshot.docs.map((doc) => {
          let member = doc.data();
          member.id = doc.id;
          return member;
        });
        return members;
      } catch (error) {
        this.errorMessage = error.message;
        return null;
      }
    },
  },
  async mounted() {
    if (this.eventId) {
      this.event = await this.getEvent(this.eventId);
      this.members = await this.getMembers(this.eventId);
    }
  },
};
</script>
